import { webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const bomberOriginalReverseWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.moveTo(503, 181) // 右下
  ctx.quadraticCurveTo(628, 215, 690, 280) // 左下
  ctx.moveTo(480, 250) // 左上
  ctx.quadraticCurveTo(596, 275, 648, 314) // 右上
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 斜線上周り_外
  ctx.moveTo(555, 90) // 左上外
  ctx.quadraticCurveTo(533, 129, 513, 179) // 左下
  ctx.quadraticCurveTo(635, 215, 688, 275) // 右上
  ctx.quadraticCurveTo(655, 145, 555, 90) // 左上
  // 斜線上周り_内
  ctx.moveTo(513, 175) // 左下
  ctx.quadraticCurveTo(639, 211, 682, 271) // 右上
  ctx.quadraticCurveTo(655, 155, 555, 95) // 左上
  // 斜線中周り＿外
  ctx.moveTo(509, 188) // 左上
  ctx.quadraticCurveTo(490, 246, 490, 248) // 左下
  ctx.quadraticCurveTo(580, 265, 646, 308) // 右下
  ctx.quadraticCurveTo(682, 276, 685, 280) // 右上
  ctx.quadraticCurveTo(617, 214, 509, 188) // 左上
  // 斜線中周り＿内
  ctx.moveTo(494, 244) // 左上
  ctx.quadraticCurveTo(580, 265, 648, 302) // 右下
  ctx.quadraticCurveTo(682, 276, 681, 284) // 右上
  ctx.quadraticCurveTo(617, 217, 509, 195) // 左上
  // 斜線下周り＿外
  ctx.moveTo(489, 256) // 左上
  ctx.quadraticCurveTo(521, 330, 584, 354) // 右下
  ctx.quadraticCurveTo(640, 312, 640, 312) // 左上
  ctx.quadraticCurveTo(581, 278, 489, 256) // 右下
  // 斜線下周り＿内
  ctx.moveTo(493, 263) // 左上
  ctx.quadraticCurveTo(578, 282, 631, 313) // 右下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  // 上段
  crossLaceOfBomberWeb(ctx, laceColor, 270, -65)
  crossLaceOfBomberWeb(ctx, laceColor, 315, -45)
  crossLaceOfBomberWeb(ctx, laceColor, 360, -22)
  crossLaceOfBomberWeb(ctx, laceColor, 400, 5)
  webKnots(ctx, laceColor, -110, -920, 80, 0.8) // 親指側
  webKnots(ctx, laceColor, -290, -810, 80, 0.8) // 小指側
  // 下段
  crossLaceOfBomberWeb(ctx, laceColor, 235, 0)
  crossLaceOfBomberWeb(ctx, laceColor, 290, 15)
  crossLaceOfBomberWeb(ctx, laceColor, 337, 38)
}

const crossLaceOfBomberWeb = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // // 左側
  ctx.beginPath()
  ctx.moveTo(259 + x, 275 + y) // 左上
  ctx.quadraticCurveTo(270 + x, 274 + y, 290 + x, 253 + y) // 左下
  ctx.quadraticCurveTo(285 + x, 244 + y, 280 + x, 250 + y) // 右下
  ctx.quadraticCurveTo(256 + x, 265 + y, 256 + x, 265 + y) // 右上
  ctx.quadraticCurveTo(254 + x, 269 + y, 259 + x, 275 + y) // 左上
  ctx.fill()
  // // 断面ライン
  ctx.moveTo(257 + x, 265 + y) // 左下
  ctx.quadraticCurveTo(277 + x, 257 + y, 283 + x, 249 + y) // 右上
  ctx.stroke()
  ctx.closePath()

  // 右側
  ctx.beginPath()
  ctx.moveTo(266 + x, 247 + y) // 左上
  ctx.quadraticCurveTo(271 + x, 263 + y, 270 + x, 285 + y) // 左下
  ctx.quadraticCurveTo(273 + x, 285 + y, 276 + x, 278 + y) // 右下
  ctx.quadraticCurveTo(277 + x, 250 + y, 271 + x, 237 + y) // 右上
  ctx.quadraticCurveTo(266 + x, 238 + y, 266 + x, 247 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(266 + x, 247 + y) // 下
  ctx.quadraticCurveTo(274 + x, 263 + y, 270 + x, 285 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}

// const crossLaceOfBomberWeb = (
//   ctx: CanvasRenderingContext2D,
//   color: string,
//   x: number,
//   y: number,
//   numerator?: number,
//   scaleSize?: number
// ): void => {
//   ctx.lineWidth = 0.8
//   ctx.strokeStyle = '#282828'
//   ctx.fillStyle = color
//   if (numerator !== undefined && numerator !== 0) {
//     ctx.save()
//     ctx.rotate((numerator * Math.PI) / 180)
//   }
//   if (scaleSize !== undefined) {
//     ctx.scale(scaleSize, scaleSize)
//   }

//   // 左側
//   ctx.beginPath()
//   ctx.moveTo(510, 319) // 左上
//   ctx.quadraticCurveTo(507, 352, 507, 352) // 左下
//   ctx.quadraticCurveTo(512, 355, 516, 353) // 右下下
//   ctx.quadraticCurveTo(522, 325, 519, 315) // 右上
//   ctx.quadraticCurveTo(512, 312, 510, 319) // 左上
//   ctx.fill()
//   // 断面ライン
//   ctx.moveTo(511, 319) // 左上
//   ctx.quadraticCurveTo(513, 332, 507, 350) // 左下
//   ctx.stroke()
//   ctx.closePath()

//   // 右側
//   ctx.beginPath()
//   // ctx.strokeStyle = 'blue' // '#383838'
//   ctx.moveTo(494, 334) // 左上
//   ctx.quadraticCurveTo(494, 338, 496, 343) // 左下
//   ctx.quadraticCurveTo(525, 337, 533, 337) // 右下
//   ctx.quadraticCurveTo(533, 333, 530, 328) // 右上
//   ctx.quadraticCurveTo(510, 328, 494, 334) // 左上
//   ctx.fill()
//   // // 断面ライン
//   ctx.moveTo(496, 343) // 下
//   ctx.quadraticCurveTo(521, 334, 533, 337) // 右下
//   ctx.stroke()
//   ctx.closePath()

//   if (numerator !== undefined) {
//     ctx.restore()
//   }
// }
